/**
 * localStorage/sessionStorage key constants shared across Passport auth stores.
 *
 * AUTH_STORE_STORAGE_KEY specifically: three independent Zustand `persist` stores
 * write to this same key name — @passport/store and @passport/auth-core (both running
 * in the login app, on the same origin, for the Google-OAuth vs. email/password login
 * paths respectively) and market-hub's own separate @marketplace/store. Centralized
 * here so the name can never drift between them without every consumer catching it at
 * compile time via the shared import, rather than three independently-hardcoded string
 * literals silently going out of sync.
 */
export const AUTH_STORE_STORAGE_KEY = 'auth-store';
